import { exportTemplatesFactory } from '@eas/common-web';
import { ExportTags } from '../../../../common/export-tags';

export const ExportTemplates = exportTemplatesFactory({
  exportTag: ExportTags.EXPORT_TEMPLATE_GRID,
});
